// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_EventReprocessInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subscriptions/admin/events/{id}/reprocess
 *
 * No body required — id is a URL path parameter. The replay payload is
 * NEVER read from the request (see admin.php::events_reprocess() docblock) —
 * it is decoded from the STORED subscription_events row.
 */
import { registerContract } from './validate'

export interface Subscriptions_EventReprocessInput {}

registerContract('Subscriptions_EventReprocessInput', {})
